package com.zq.my_official_website

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import myofficialwebsite_master.composeapp.generated.resources.Res
import myofficialwebsite_master.composeapp.generated.resources.noto_sans_sc_vf
import org.jetbrains.compose.resources.Font

/**
 * Web（Skiko/CanvasKit）在 <canvas> 上直接绘制文字，不走浏览器字体栈，
 * 因此必须显式加载中文字体，否则 CJK 字符会被渲染成豆腐块（□）。
 * 这里复用 composeResources 中的 Noto Sans SC，与 jvm/android 端保持一致。
 */
@Composable
actual fun AppFontFamily(): FontFamily = FontFamily(
    Font(Res.font.noto_sans_sc_vf, weight = FontWeight.Normal),
)
